import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickProductCard from "@/features/pathpick/components/product/PathPickProductCard";
import { PathPickProduct } from "@/features/pathpick/types";
import { START_GUIDE_CARD_VIEW } from "@/features/pathpick/features/start-guide/constants";

interface Props {
  item: PathPickProduct;
  isSelected: boolean;
  // 등록·주문이 시작된 뒤에는 대상이 바뀌면 안 된다.
  isSelectionLocked?: boolean;
  onToggleSelect: () => void;
  onOpenSizeStock: () => void;
  // 미지정이면 주문 버튼은 자리만 지키고 아무 동작도 하지 않는다(담은 상품 안내).
  onOrder?: () => void;
}

/**
 * 가이드의 담은 상품 카드.
 *
 * 운영 담은 상품 카드(`PathPickBasketProductGridItem`)와 같은 `PathPickProductCard` 를 쓰되
 * 하단 액션만 다르게 준다 — 가이드에서는 삭제를 노출하지 않는다. 두 상품이 고정 구성이라
 * 삭제로 화면이 비면 안내 자체가 성립하지 않기 때문이다.
 *
 * 주문 버튼은 실제 카드와 같은 모습을 보여주기 위한 것이라 주문 전후로 바뀌지 않는다 —
 * 주문을 실제로 여는 곳은 각 화면의 큰 주문 버튼이다.
 */
function PathPickStartGuideSavedProductCard({
  item,
  isSelected,
  isSelectionLocked = false,
  onToggleSelect,
  onOpenSizeStock,
  onOrder,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <PathPickProductCard
      item={item}
      marketPriceBasis={"bidPrice"}
      viewOverride={START_GUIDE_CARD_VIEW}
      isSelected={isSelected}
      onToggleSelect={isSelectionLocked ? undefined : onToggleSelect}
      onOpenSizeStock={onOpenSizeStock}
      isOptionsPrefetchDisabled={true}
      actions={
        <AppButton
          variant={"white"}
          width={"100%"}
          onClick={onOrder}
          chakraProps={{ px: "8px" }}
        >
          <Flex gap={"4px"} alignItems={"center"} justifyContent={"center"}>
            <CustomIcon src={"cart"} width={16} height={16} />
            <Text textStyle={"body-sm-bold"}>
              {t("path_pick:search_products.product_list.order")}
            </Text>
          </Flex>
        </AppButton>
      }
    />
  );
}

export default PathPickStartGuideSavedProductCard;
